import PaymentsPopover from './PaymentsPopover'
export default PaymentsPopover
